import { all, fork, put, takeLatest } from "redux-saga/effects";
import actions from "../actions";
import CONSTANTS from "../CONSTANTS";

export const POLICY_URL = "/services/rcp/profile/policy/";
export function* getMyPolicies() {
  yield takeLatest(CONSTANTS.GET_MAIN_MY_POLICIES, function* () {
    try {
      yield put(actions.setMyPolicies(null));

      const url = POLICY_URL + "GetMyPolicies" + "?showChildPolicies=true";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setMyPolicies(data));
    } catch (e) {
      yield put(actions.setMyPolicies([]));
      console.error(e);
    }
  });
}
export function* getMyManagerByPolicyId() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_MY_MANAGER_BYPOLICYID,
    function* (action) {
      try {
        yield put(actions.setMyManagerByPolicyId(null));

        const url =
          POLICY_URL + "GetMyManagerByPolicyId?policyId=" + action.payload;
        const res = yield window.mainAxios.get(url).then((r) => r.data);
        // console.log(res)
        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        const data = res.data;

        yield put(actions.setMyManagerByPolicyId(data));
      } catch (e) {
        yield put(actions.setMyManagerByPolicyId({}));
        console.error(e);
      }
    }
  );
}
export default function* policySaga() {
  yield all([fork(getMyPolicies), fork(getMyManagerByPolicyId)]);
}
